import React from "react";
import { Controller, FieldValues, UseFormReturn } from "react-hook-form";
import TimeInput from "../../components/Timeinput/TimeInput";
import { FormField, WuiltContext } from "@/shared/types";

interface TimeFieldProps {
  isError?: boolean;
  field: FormField;
  useFormProps: UseFormReturn<FieldValues, any>;
  isSubmitting: boolean;
  wuiltContext?: WuiltContext;
}

const TimeField: React.FC<TimeFieldProps> = ({
  isError,
  useFormProps,
  field,
  wuiltContext,
}) => {
  return (
    <Controller
      control={useFormProps?.control}
      name={field?.id}
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      render={({ field: { ref, ...fieldProps } }) => (
        <TimeInput
          isError={isError}
          {...fieldProps}
          wuiltContext={wuiltContext}
        />
      )}
    />
  );
};

export default TimeField;
